module.exports = "https://99designs-start-assets.imgix.net/js/0c84e191b5851cebd8eb960351a501e6.png";